import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import './index.scss'
import {Box, Paper} from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import TrackShipmentForm from './components/Form'
import ShipmentData from './components/ShipmentData'
import ShipmentHeader from './components/ShipmentData/ShipmentHeader'
import Breadcrumb from 'shared/BreadCrumb'
import {ENDPOINT} from 'config/path'
import {toggleLoginPopup} from 'features/Login/login.slice'
import {useLocation, useNavigate} from 'react-router-dom'
import {LazyLoadComponent} from 'react-lazy-load-image-component'
import {resetState} from './trackshipment.slice'

const breadcrumbList = [
    {
        path: `${ENDPOINT.basePath}${ENDPOINT.dashboard}`,
        label: (
            <React.Fragment>
                <HomeIcon /> Home
            </React.Fragment>
        )
    },
    {
        label: 'Track shipments'
    }
]

const TrackShipments = () => {
    const location = useLocation()
    const isLoggedIn = useSelector((state: any) => state.login.isLoggedIn)
    const defaultValues = useSelector((state: any) => state.trackShipment.initialValues)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (
            defaultValues?.carrier === '-Select-' ||
            defaultValues?.airlineCode?.length < 1 ||
            defaultValues?.airWayBill?.length < 1
        ) {
            navigate(ENDPOINT.homepage)
        }
        if (location.pathname === ENDPOINT.viewSchedule) {
            if (isLoggedIn) {
                dispatch(toggleLoginPopup(false))
            } else {
                dispatch(toggleLoginPopup(true))
            }
        }
        return () => {
            dispatch(resetState())
            dispatch(toggleLoginPopup(false))
        }
    }, [])
    return (
        <Box className='track_shipments_main_container'>
            <Breadcrumb list={breadcrumbList} />
            <Box className='page-backdrop' />
            <Box className='page-container'>
                <Box className='page-content'>
                    <ShipmentHeader />
                    <Paper className='view-container'>
                        <Box className='page-input-form content-padding'>
                            <LazyLoadComponent>
                                <TrackShipmentForm inPage />
                            </LazyLoadComponent>
                        </Box>
                        <Box className='page-table content-padding'>
                            <ShipmentData />
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </Box>
    )
}

export default TrackShipments
